<template>
    <div class="tempContent">
        <!--新增按钮-->
        <t-button theme="primary" @click="addClick">
            <template #icon><add-icon /></template>
            新增
        </t-button>

        <t-table
            :data="data" 
            :columns="columns"
            tableLayout="auto"
            show-header="true"
            cell-empty-content="--"
            row-key="index"
            resizable
            lazy-load
            size="large"
            bordered
            hover
            @drag-sort="onDragSort"
            drag-sort="row-handler"
        >
            <template #orderNumber="{ row, rowIndex }">
                {{ rowIndex + 1 }}
            </template>
        </t-table>

        <t-drawer
            v-model:visible="visible"
            header="新增设施" 
            size="800px"
        >
          <div class="formWrap">
              <!--设施名称-->
              <div class="formItem">
                  <div class="formItemTitle">
                      设施名称
                  </div>
                  <div class="formElement">
                      <t-input
                          placeholder="请输入设施名称"
                          :maxlength="12"
                          show-limit-number
                          clearable
                          size="large"
                        />
                  </div>
              </div>

              <!--设施组-->
              <div class="formItem">
                  <div class="formItemTitle">
                        设施组
                  </div>
                  <div class="formElement">
                        <t-select
                            :options="groupOption"
                            filterable
                            clearable
                            placeholder="请选择"
                            size="large"
                        />                  
                  </div>
              </div>

              <!--选项类型-->
              <div class="formItem">
                  <div class="formItemTitle">
                        选项类型
                  </div>
                  <div class="formElement">
                        <t-radio-group
                            class="radioGroup"
                            v-model="selectedType"
                            :options="selectTypeOption"
                            @change="onTypeChange"  
                        />                  
                  </div>
              </div>
          </div>

        </t-drawer>

    </div>
</template>

<script setup lang="jsx">
    /**设施管理 */

import { AddIcon,MoveIcon } from 'tdesign-icons-vue-next';
import { ref,computed  } from 'vue';
import { useRouter } from 'vue-router'; 


const router = useRouter(); 
const visible=ref(false);

//新增按钮跳转
const addClick=()=>{
    visible.value = true;
};


const switchStatus=(row)=>{
    row.status=row.status==='已启用'?'已停用' : '已启用';
}

//列表字段
const columns=ref([
    { 
        colKey: 'drag',
        title: '',
        cell: (h) => (
            <span>
              <MoveIcon />
            </span>
          ),
        width:'48',
    },
    { colKey: 'orderNumber', title: '序号'},
    { colKey: 'facilityId', title: '设施ID'},
    { colKey: 'facilityTitle', title: '设施名称'},
    { colKey: 'facilityOption', title: '设施选项'},
    { colKey: 'optionType', title: '选项类型'},
    { colKey: 'facilityGroup', title: '所属设施组'},
    { colKey: 'status', title: '状态'},
    { colKey: 'updateTime', title: '修改时间' },
    { colKey: 'updateBy', title: '修改人' },
    { 
        colKey: 'action', 
        title: '操作', 
        width: 200,
        cell:(h, { row })=>(
          <>
            <t-link
              class="actionItem"
              theme="primary" hover="color" onClick={() => editClick(row)}>
                编辑
            </t-link>

            <t-link
              class="actionItem"
              theme='primary'
              hover="color"
              onClick={() => switchStatus(row)}
              style="margin-left: 16px;"
            >
                {row.status === '已启用' ? '停用' : '启用'}
            </t-link>

            {row.status === '已停用' && (
                <t-link
                  class="actionItem"
                  theme="danger"
                  hover="color"
                  onClick={() => deleteItem(row)}
                  style="margin-left: 16px;"
                >
                  删除
                </t-link>
            )}
          </>
        )
    },
]);

//查看详情按钮跳转
const detailClick=()=>{
  router.push('/camp/camp-detail')
}

//表格数据
const campSiteData =ref([
    { 
        orderNumber:1,
        facilityId:'0001',
        facilityTitle:'营地类型',
        facilityOption:'亲子营地，宠物营地，公园营地',
        optionType:'多选',
        facilityGroup:'营地环境',
        status:'已启用',
        updateTime:'2024-12-09 08:32:48',
        updateBy:'admin',
    },
    {
        orderNumber:2,
        facilityId:'0002',
        facilityTitle:'宠物',
        facilityOption:'可带宠物，不可带宠物',
        optionType:'单选',
        facilityGroup:'营地环境',
        status:'已停用',
        updateTime:'2024-12-09 08:32:48',
        updateBy:'admin',
    },
    {
        orderNumber:3,
        facilityId:'0003',
        facilityTitle:'宠物',
        facilityOption:'可带宠物，不可带宠物',
        optionType:'单选',
        facilityGroup:'营地环境',
        status:'已停用',
        updateTime:'2024-12-09 08:32:48',
        updateBy:'admin',
    },
  ]);
  

  // 拖动更新排序序号
  const onDragSort = ({ newData, currentIndex, targetIndex }) => {
    campSiteData.value = newData;
    
    // 只更新受影响的行的序号
    const start = Math.min(currentIndex, targetIndex);
    const end = Math.max(currentIndex, targetIndex);
    for (let i = start; i <= end; i++) {
      campSiteData.value[i].orderNumber = i + 1;
    }
  };

const data = computed(() => campSiteData.value);

const groupOption= [
    { label: '营地环境', value: '1'},
    { label: '配套设施', value: '2'},
];


const selectedType = ref(''); 
const selectTypeOption=[
    {
        value: '1',
        label: '单选',
    },
    {
        value: '2',
        label: '多选',
    },
]; 

  const onTypeChange=(value)=>{
      console.log('选中的选项类型：', value);
  }
  
</script>

<style scoped >
    @import "./agreement-admin.css";
    @import "../../../components/style/style-content.css";
    @import "../../../components/style/style-table.css";
    @import "../../../components/style/style-drawer.css";
</style>